export default "__VITE_ASSET__fu_LK9cE__"